import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=2b801af4&scoped=true&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=2b801af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b801af4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Textarea: require('/vercel/path0/components/forms/Textarea.vue').default})
